import { useState } from "react";

function KnowledgeHub() {
  const [selectedVideo, setSelectedVideo] = useState(null);

  const categories = [
    {
      title: "☁ Storage & Files",
      resources: [
        {
          title: "Backup Process",
          type: "ppt",
          subtitle: "Backup Process Presentation",
          thumbnail:
            "https://storage.googleapis.com/lsp-webstore/Dashboard/Storage.png",
          fileUrl:
            "https://storage.googleapis.com/lsp-webstore/Dashboard/Backup-Plan.pptx",
        },
        {
          title: "My Cloud Home",
          type: "video",
          subtitle: "Storage Training Video",
          thumbnail:
            "https://storage.googleapis.com/lsp-webstore/Dashboard/Cloud.png",
          fileUrl:
            "https://app.animaker.com/animo/3KaLbcP0oQsUjvgL/",
        },
        {
          title: "NAS Storage Process",
          type: "pdf",
          subtitle: "Reference Documentation",
          thumbnail:
            "https://storage.googleapis.com/lsp-webstore/Dashboard/NAS.png",
          fileUrl:
            "https://storage.googleapis.com/lsp-webstore/Dashboard/LSP%20Backup%20System.pdf",
        },
      ],
    },
    {
      title: "🛡 HR & Policies",
      resources: [
        {
          title: "POSH Awareness",
          type: "ppt",
          subtitle: "Training Presentation",
          thumbnail:
            "https://storage.googleapis.com/lsp-webstore/Dashboard/POSH.png",
          fileUrl:
            "https://storage.googleapis.com/lsp-webstore/Dashboard/POSH.pdf",
        },
      ],
    },

    {
      title: "🎤 Lectures by Rohin Sir",
      resources: [
        {
          title: "Lecture 1",
          type: "video",
          subtitle: "Recorded Lecture",
          thumbnail:
            "https://storage.googleapis.com/lsp-webstore/Dashboard/Lectures.png",
          fileUrl:
            "https://storage.googleapis.com/lsp-webstore/Videos/Rohin_Lecture1.mp4",
        },
        {
          title: "Lecture 2",
          type: "video",
          subtitle: "Recorded Lecture",
          thumbnail:
            "https://storage.googleapis.com/lsp-webstore/Dashboard/Lectures.png",
          fileUrl:
            "https://storage.googleapis.com/lsp-webstore/Videos/Rohin_Lecture2.mp4",
        },
      ],
    },

    

    {
      title: "🚀 Internal Tools",
      resources: [
        {
          title: "Dashboard Overview",
          type: "video",
          subtitle: "Internal Training Video",
          thumbnail:
            "https://storage.googleapis.com/lsp-webstore/Homepage/Dashboard.jpg",
          fileUrl:
            "https://storage.googleapis.com/lsp-webstore/Videos/Dashboard.mp4",
        },
        {
          title: "LSP AI Assistant",
          type: "video",
          subtitle: "Internal Training Video",
          thumbnail:
            "https://storage.googleapis.com/lsp-webstore/Dashboard/ai.jpg",
          fileUrl:
            "https://storage.googleapis.com/lsp-webstore/Videos/LSP_AI.mp4",
        },
      ],
    },
    {
      title: "🎓 Training Sessions",
      resources: [
        {
          title: "Building The Future Of Datacenters by Sindhu Ma'am",
          type: "video",
          subtitle: "Internal Training Video",
          thumbnail:
            "https://storage.googleapis.com/lsp-webstore/Homepage/Training.jpg",
          fileUrl:
            "https://storage.googleapis.com/lsp-webstore/Videos/Sindhu_Mam.mp4",
        },
      ],
    },
    {
      title: "💬 Communication",
      resources: [
        {
          title: "Mattermost Essentials",
          type: "video",
          subtitle: "Communication Training",
          thumbnail:
            "https://storage.googleapis.com/lsp-webstore/Homepage/Training.jpg",
          fileUrl:
            "https://storage.googleapis.com/lsp-webstore/Videos/Mattermost.mp4",
        },
        {
          title: "Roundcube Mail",
          type: "video",
          subtitle: "Communication Training",
          thumbnail:
            "https://storage.googleapis.com/lsp-webstore/Homepage/Training.jpg",
          fileUrl:
            "https://storage.googleapis.com/lsp-webstore/Videos/Roundcube.mp4",
        },
        {
          title: "Thunderbird Setup",
          type: "video",
          subtitle: "Communication Training",
          thumbnail:
            "https://storage.googleapis.com/lsp-webstore/Homepage/Training.jpg",
          fileUrl:
            "https://storage.googleapis.com/lsp-webstore/Videos/Thunderbird.mp4",
        },
      ],
    },

    {
      title: "📦 Company Systems",
      resources: [
        {
          title: "InvenTree Basics",
          type: "video",
          subtitle: "Internal Training Video",
          thumbnail:
            "https://storage.googleapis.com/lsp-webstore/Homepage/Training.jpg",
          fileUrl:
            "https://storage.googleapis.com/lsp-webstore/Videos/InvenTree.mp4",
        },
      ],
    },

    
  ];

  const getTypeColor = (type) => {
    switch (type) {
      case "video":
        return "bg-red-100 text-red-700";
      case "ppt":
        return "bg-orange-100 text-orange-700";
      case "pdf":
        return "bg-blue-100 text-blue-700";
      default:
        return "bg-gray-100 text-gray-700";
    }
  };

  const getTypeLabel = (type) => {
    switch (type) {
      case "video":
        return "VIDEO";
      case "ppt":
        return "PPT";
      case "pdf":
        return "PDF";
      default:
        return "FILE";
    }
  };

  const handleResourceClick = (resource) => {
    if (resource.type === "video") {
      setSelectedVideo(resource);
    } else {
      window.open(resource.fileUrl, "_blank");
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F7FB]">
      {/* Header */}
      <div className="relative overflow-hidden bg-gradient-to-r from-[#0F172A] via-[#111827] to-[#1F2937] text-white px-10 py-14">
        <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_top_right,_#C00000,_transparent_60%)]" />

        <div className="relative z-10">
          <h1 className="text-4xl font-bold tracking-wide">
            Knowledge Hub
          </h1>

          <p className="mt-3 text-gray-300 max-w-2xl">
            Learn the tools, systems and workflows used across
            LightSpeed Photonics. Browse videos, presentations and
            documentation in one place.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="px-10 py-10 space-y-12">
        {categories.map((category) => (
          <div key={category.title}>
            {/* Category Title */}
            <h2 className="text-xl font-semibold text-gray-800 mb-6 border-l-4 border-[#C00000] pl-3">
              {category.title}
            </h2>

            {/* Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
              {category.resources.map((resource) => (
                <div
                  key={resource.title}
                  onClick={() => handleResourceClick(resource)}
                  className="
                    group
                    bg-white
                    rounded-2xl
                    overflow-hidden
                    shadow-sm
                    border
                    border-gray-100
                    cursor-pointer
                    hover:shadow-xl
                    hover:-translate-y-1
                    transition-all
                    duration-300
                  "
                >
                  {/* Thumbnail */}
                  <div className="relative h-44 overflow-hidden">
                    <img
                      src={resource.thumbnail}
                      alt={resource.title}
                      className="
                        w-full
                        h-full
                        object-cover
                        group-hover:scale-110
                        transition-transform
                        duration-500
                      "
                    />

                    {/* Dark Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />

                    {/* Type Badge */}
                    <span
                      className={`absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-semibold ${getTypeColor(
                        resource.type
                      )}`}
                    >
                      {getTypeLabel(resource.type)}
                    </span>

                    {/* Play Icon only for Videos */}
                    {resource.type === "video" && (
                      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition">
                        <div className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center shadow-lg">
                          <svg
                            className="w-8 h-8 text-red-600 ml-1"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M6 4l10 6-10 6V4z" />
                          </svg>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Card Content */}
                  <div className="p-5">
                    <h3 className="font-semibold text-gray-900 group-hover:text-[#C00000] transition">
                      {resource.title}
                    </h3>

                    <p className="text-sm text-gray-500 mt-2">
                      {resource.subtitle}
                    </p>

                    <div className="mt-5 flex justify-between items-center">
                      <span className="text-xs text-gray-400">
                        LightSpeed Learning
                      </span>

                      <span className="text-[#C00000] text-sm font-medium group-hover:translate-x-1 transition">
                        {resource.type === "video"
                          ? "Watch →"
                          : resource.type === "ppt"
                          ? "Open PPT →"
                          : "Open PDF →"}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
              </div>

      {/* ================= VIDEO PLAYER MODAL ================= */}
      {selectedVideo && (
        <div
          className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-6"
          onClick={() => setSelectedVideo(null)}
        >
          <div
            className="relative bg-[#111827] rounded-2xl shadow-2xl w-full max-w-5xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={() => setSelectedVideo(null)}
              className="absolute top-4 right-4 z-20 w-10 h-10 rounded-full bg-black/60 hover:bg-red-600 text-white text-xl transition"
            >
              ✕
            </button>

            {/* Video */}
            <video
              controls
              autoPlay
              className="w-full bg-black max-h-[75vh]"
            >
              <source
                src={selectedVideo.fileUrl}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>

            {/* Footer */}
            <div className="p-6 text-white">
              <div className="flex items-center justify-between flex-wrap gap-3">

                <div>
                  <h2 className="text-2xl font-bold">
                    {selectedVideo.title}
                  </h2>

                  <p className="text-gray-400 mt-2">
                    {selectedVideo.subtitle}
                  </p>
                </div>

                <div className="px-4 py-2 rounded-full bg-[#C00000] text-white font-medium">
                  Internal Learning
                </div>

              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default KnowledgeHub;